import { useQuery } from '@tanstack/react-query'
import { SelectProps } from '@veracity/vui'

import { portfoliosClient } from '@/api'

const BASE_QUERY_KEY = portfoliosClient.QUERY_KEY
export const usePortfoliosList = () => {
  const { data } = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: portfoliosClient.getAll
  })

  return data?.map(x => ({
    text: x.name || '',
    value: x.id
  })) as SelectProps['options']
}
